import { TableCell, Typography } from "@material-ui/core";
import React from "react";
import TranslatedMessage from "../../../../translations/TranslatedMessage";

const ExamFullSelectionCells = () => {
  return (
    <TableCell colSpan={2}>
      <Typography variant={"subtitle2"} color="error">
        <TranslatedMessage id="application.examLocationAndDate.examFull" />
      </Typography>
    </TableCell>
  );
};

export default ExamFullSelectionCells;
